export default __webpack_public_path__ + "static/media/undraw_in_sync_re_jlqd.1f19dace.svg";